import { TileLayer, useLeaflet } from "react-leaflet"

const HERE_API_KEY = process.env.REACT_APP_HERE_API_KEY
//const MAPTILER_API_KEY = process.env.REACT_APP_MAPTILER_API_KEY

export const HereTileLayer = ({ type = "base" }: { type?: "base" | "traffic" }) => {
  const leaflet = useLeaflet()

  return <TileLayer url={getTileLayerUrl(type)} subdomains="1234" leaflet={leaflet} />
}

function getTileLayerUrl(type: "base" | "traffic" = "base") {
  if (type === "traffic") {
    return `https://traffic.maps.hereapi.com/v3/flow/mc/{z}/{x}/{y}/png?size=256&apiKey=${HERE_API_KEY}`
  }

  return `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/png?size=256&apiKey=${HERE_API_KEY}`

  //return `https://api.maptiler.com/maps/streets-v2/256/{z}/{x}/{y}.png?key=${MAPTILER_API_KEY}`
}
